import React, { PureComponent } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input
} from "reactstrap";

export default class ConfirmationModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedBusiness: null
    };

    this.onBusinessSelect = this.onBusinessSelect.bind(this);
    this.onConfirm = this.onConfirm.bind(this);
    this.close = this.close.bind(this);
  }

  onBusinessSelect(e) {
    this.setState({ selectedBusiness: e.target.value });
  }

  renderOptions() {
    return this.props.options.map(option => (
      <option key={option.entity.id} value={option.entity.id}>
        {option.entity.name}
      </option>
    ));
  }

  onConfirm() {
    this.props.onConfirm(this.state.selectedBusiness);
    this.setState({ selectedBusiness: null });
  }
  close() {
    this.setState({ selectedBusiness: null });
    this.props.close();
  }

  render() {
    return (
      <Modal
        isOpen={this.props.open}
        toggle={this.toggle}
        className={this.props.className}
      >
        <ModalHeader toggle={this.props.close}>Confirm</ModalHeader>
        <ModalBody>
          {this.props.message}
          {this.props.options && (
            <FormGroup>
              <Label>Remove User from Business</Label>
              <Input
                type="select"
                className="form-control"
                onChange={this.onBusinessSelect}
              >
                <option
                  selected={this.state.selectedBusiness === null}
                  default
                  value={null}
                >
                  Select a Business
                </option>
                {this.renderOptions()}
              </Input>
            </FormGroup>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onConfirm}>
            {this.props.isSubmitting && (
              <i
                className="fa fa-circle-o-notch fa-spin"
                style={{ marginRight: 5 }}
              />
            )}
            Confirm
          </Button>{" "}
          <Button color="secondary" onClick={this.close}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Components/ConfirmationModal.js